import React, { Component } from "react";
import styled from "styled-components";
import debounce from "lodash.debounce";
import { connect } from "react-redux";

import { setNightMode } from "store";

import Container from "partials/Container";
import GridElement from "partials/GridElement";

import Media, { ScreenWidth } from "css/Media";
import { BookVisitAvailabilityChecker } from "views/Accommodation/BookVisitAvailabilityChecker";

export class FrontpageHero extends Component {
  state = {
    checkerHeight: 0,
  };

  componentWillMount() {
    this.checkScreenSize();
  }

  componentDidMount() {
    window.addEventListener("resize", debounce(this.checkScreenSize.bind(this)), 500);
    if (this.props.data.night_mode) {
      this.props.setNightMode(true);
      this.setModuleObservable();
    }
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.checkScreenSize());
    if (this.props.data.night_mode) {
      this.props.setNightMode(false);
      if (this.observer) {
        this.observer.disconnect();
      }
    }
  }

  setModuleObservable() {
    this.io = new IntersectionObserver(
      (el, observer) => {
        let element = el[0];
        this.observer = observer;
        this.setState({ ratio: element.intersectionRatio });

        if (element.intersectionRatio >= 0.7) {
          this.setState({ inSight: true });
          this.props.setNightMode(true);
          document.getElementsByClassName("form-control input")[0].style.cssText =
            "background-color: #1F1F1F; color: #FFFFFF; transition: background-color .5s ease-in";
        } else {
          this.setState({ inSight: false });
          this.props.setNightMode(false);
          document.getElementsByClassName("form-control input")[0].style.cssText =
            "background-color: #FFFFFF; color: #1F1F1F;  transition: background-color .5s ease-in";
        }
      },
      {
        threshold: 0.7,
      }
    );

    this.io.observe(document.getElementById("wrapper"));
  }

  checkScreenSize() {
    let isMobile = false;

    if (ScreenWidth.lessThan("s")) {
      isMobile = true;
    }
    this.setState({ isMobile: isMobile });
  }

  render() {
    const { data } = this.props;
    const { isMobile, checkerHeight, inSight } = this.state;

    return (
      <Wrapper isDark={data.night_mode ? (inSight ? 1 : 0) : 0} id="wrapper">
        <Container grid mobileBleed={isMobile} rows={isMobile ? "1fr 50px" : "1fr 125px"}>
          <GridElement
            colStart={{ default: 1, s: 3 }}
            colEnd={{ default: 8, s: 22 }}
            rowStart={{ default: 1, s: 1 }}
            rowEnd={{ default: 2, s: 3 }}
            rowSpan
          >
            {isMobile && data.image ? (
              <ImageDiv image={data.image} height={checkerHeight} />
            ) : data.image ? (
              <ImageDiv image={data.image} height={checkerHeight} />
            ) : null}
          </GridElement>
          <GridElement
            colStart={{ default: 1, s: 1 }}
            colEnd={{ default: 7, s: 12 }}
            rowStart={1}
            rowEnd={2}
            align="end"
          >
            <h1>{data.header_text}</h1>
          </GridElement>
        </Container>
        <BookVisitAvailabilityChecker />
      </Wrapper>
    );
  }
}

const mapStateToProps = (state) => ({
  nightMode: state.nightMode,
});

const actions = {
  setNightMode,
};

export default connect(mapStateToProps, actions)(FrontpageHero);

const Wrapper = styled.section`
  background-color: ${(props) => (props.isDark ? props.theme.colors.text : props.theme.colors.negative)};
  color: ${(props) => (props.isDark ? props.theme.colors.negative : props.theme.colors.text)};
  margin-top: -160px;
  height: 100vh;
  transition: all 0.5s ease-in;

  ${Media.greaterThan("s")`
        margin-top: -220px;
    `}

  ${Media.greaterThan("m")`
        margin-top: -260px;
        margin-bottom: ${(props) => props.theme.spacing.blockS};
    `}

    >.container {
    height: calc(100vh - 278px);

    ${Media.greaterThan("s")`
            padding-top: 45px;
            height: calc(100vh - 168px);
        `}

    h1 {
      transform: translateY(50%);
      z-index: 1;
      padding-left: 25px;

      ${Media.greaterThan("s")`
                padding: 0;
                transform: translateY(0%);
            `}
    }
  }
`;

const ImageDiv = styled.div`
  width: 100%;
  height: 100%;
  background-position: center;
  background-image: url(${(props) => props.image.sizes.full.url});
  background-repeat: no-repeat;
  background-size: cover;
`;
